import { shouldForwardProp } from '@/utils/style.utils';
import styled from '@emotion/styled';
import { COLOR_VARIANTS, Icons, color } from '@tajawal/ct-web-design-system';
import { CustomTheme } from '@tajawal/ct-web-design-system/dist/theme';

const getSelectedColor = () => {
  return ({ $isSelected }) => ($isSelected ? color(COLOR_VARIANTS.AQUA100) : color(COLOR_VARIANTS.GAINSBORO));
};

const StopsWrapper = styled('div', { shouldForwardProp })<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  margin: 0px 16px;
  flex-grow: 1;
  & > .MuiDivider-root {
    margin: 0px 4px;
    flex-grow: 1;
  }

  ${({ $isSelected }) => $isSelected && `color: ${color(COLOR_VARIANTS.AQUA100)} !important`}

  > .MuiDivider-root::before, .MuiDivider-root::after {
    border-top: thin solid ${getSelectedColor()} !important;
  }
`;

const Dot = styled('div', { shouldForwardProp })<{ $isSelected: boolean }>`
  width: 4px;
  height: 4px;
  border-radius: 2px;
  background: ${getSelectedColor()};
`;

const FlightsIcon = styled(Icons.FlightsIconSolid)`
  transform: ${({ theme }: { theme?: CustomTheme }) => theme.isRtl && 'rotateY(180deg)'};
`;

export default {
  StopsWrapper,
  Dot,
  FlightsIcon,
};
